export default __webpack_public_path__ + "static/Lend_green_UK-dbcee0af3cf9c72d7b69bb3a782c16a9.png";